import axios from 'axios';
import connection from './connection';
import { ExchangeIdReq, ExchangeRatesRequest, ExchangeRatesResponseModel } from '@gtpl/shared-models/masters';

export class ExchangeRatesService{
    URL = connection.DEPLOY_URL + '/exchangeRates';


    async createExchangeRate(dto: ExchangeRatesRequest): Promise<ExchangeRatesResponseModel> {
        return await axios.post(this.URL + '/createExchangeRate',dto).then(res => {
                return res.data
        })
    }

    async  activateDeactivateExchange(Dto: ExchangeRatesRequest): Promise<ExchangeRatesResponseModel> {
        return await axios.post(this.URL + '/activateDeactivateExchange', Dto).then(res => {
            return res.data
        })
    }


    async getAllExchangeRates(req: ExchangeIdReq): Promise<ExchangeRatesResponseModel> {
        return await axios.post(this.URL + '/getAllExchangeRates',req).then(res => {
            return res.data
        })
    }

    async getAllActiveExchangeRates(): Promise<ExchangeRatesResponseModel> {
        return await axios.post(this.URL + '/getAllActiveExchangeRates',).then(res => {
            return res.data
        })
    }
           

}